export { PolicyPage as default } from '@/components/pages/Ir/Governance/Policy'
